import generateBootFunc from '../../generate-boot';
import Index from './Components/Index.vue';
import Templates from './Components/Templates.vue';
import ChangeInfo from './Components/ChangeInfo/Info.vue';
import Overview from './Components/Overview.vue';

const bootIndex = generateBootFunc(Index, 'dm-visualizer-index');
const bootScenarioTemplates = generateBootFunc(Templates, 'dm-visualizer-scenario');
const bootChangeInfo = generateBootFunc(ChangeInfo, 'dm-visualizer-scenario');
const bootOverview = generateBootFunc(Overview, 'dm-visualizer-overview');

export {
    bootIndex,
    bootScenarioTemplates,
    bootOverview,
    bootChangeInfo
};